import { Component, OnInit } from '@angular/core';
import { STALLED_CLAIM_FILTER_IDS } from '@core/constants/stalled-claim-filter.constants';

@Component({
    selector: 'rol-aging-summary',
    templateUrl: './aging-summary-home.component.html',
    styleUrls: ['./aging-summary-home.component.scss'],
    standalone: false,
})
export class AgingSummaryHomeComponent implements OnInit {
    constructor() {}

    ngOnInit(): void {}

    protected readonly STALLED_CLAIM_FILTER_IDS = STALLED_CLAIM_FILTER_IDS;
}
